import { render, staticRenderFns } from "./ManageCourse.vue?vue&type=template&id=5359915c&scoped=true"
import script from "./ManageCourse.vue?vue&type=script&lang=js"
export * from "./ManageCourse.vue?vue&type=script&lang=js"
import style0 from "./ManageCourse.vue?vue&type=style&index=0&id=5359915c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5359915c",
  null
  
)

export default component.exports